module.exports = __webpack_public_path__ + "static/media/icon-mobile-disagreed.d000cb03.svg";